// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/images/active.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--Fonts--*/
:root {
  --primary: #FF914E;
  --secondary: #07748F;
  --info: #343833;
  --white: #FFFFFF;
  --black: #000000;
  --liteblue: #e7f3f5;
  --shadeblue: #d1e6eb;
  --hrborder: #e4dede;
  --theader: #f5f7f8;
  --thinfo: #384648;
  --thborder: #dee2e6;
  --dlink: #007bff;
  --btninfo: #313232;
  --gary: #5a6e82;
  --high-to-low: linear-gradient(to right, #07748F 0%, #72B0C0 100%);
  --low-to-high: linear-gradient(90deg, #72B0C0 0, #07748F);
  --red: #f15e48;
  --green: #02681a;
  --lowgray: #A0B2B5;
}

/* ---- font family ----*/
/*--- pixels --- */
/*---font size---*/
/*---font weight---*/
/*--- percentage ---*/
/*--- display ---*/
/*--- alignment ---*/
/*--Position --*/
/*--- Text Transform ---*/
/*-- Text Style --*/
/*-- Info and paragraph --*/
.font-common, .languages .dropdown-content button, .languages .dropdown button.dropbtn, .header-style li,
.header-style a,
.header-style span {
  font-size: 14px;
  color: var(--info);
  font-weight: 600;
}

/*--Flex-box--*/
.w-flex {
  width: 100%;
  display: flex;
}

/*-- Form Label--*/
.input-fonts, .inputfields, .formlabel {
  font-size: 11px;
  color: var(--black);
}

.formlabel {
  opacity: 1;
  margin-bottom: 0.3rem;
  margin-top: 5px;
  font-weight: 500;
}

.login-btn-hover, .header-style .login-btn:hover svg path, .header-style .login-btn:hover {
  color: var(--primary);
  background-position: left;
  fill: var(--primary) !important;
}

.heading-comman, .heading-4, .heading-3, .heading-2, .card-content h4, .banner-bg-content .banner-container .banner-content .smalltext, .heading-1, .banner-bg-content .banner-container .banner-content h1 {
  font-style: normal;
  font-weight: 700;
}

.heading-1, .banner-bg-content .banner-container .banner-content h1 {
  font-size: 43px;
  line-height: 62px;
  margin-bottom: 25px;
}

.heading-2, .card-content h4, .banner-bg-content .banner-container .banner-content .smalltext {
  font-size: 35px;
  line-height: 50px;
}

.heading-3 {
  font-size: 30px;
  line-height: 60px;
  margin-bottom: 15px;
}

.heading-4 {
  font-weight: 600;
  font-size: 25px;
  line-height: 26px;
}

.inputfields {
  height: 30px;
  line-height: 30px;
  opacity: 0.8;
  padding: 0px 0.5rem;
  background: #F4F6F7;
}

/*-- Box outer --*/
.boxing {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: var(--white);
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  padding: 15px 15px;
}

.login-btn-hover, .header-style .login-btn:hover svg path, .header-style .login-btn:hover {
  color: var(--primary);
  background-position: left;
  fill: var(--primary) !important;
}

.heading-comman, .heading-1, .banner-bg-content .banner-container .banner-content h1, .heading-2, .card-content h4, .banner-bg-content .banner-container .banner-content .smalltext, .heading-3, .heading-4 {
  font-style: normal;
  font-weight: 700;
}

.heading-1, .banner-bg-content .banner-container .banner-content h1 {
  font-size: 43px;
  line-height: 62px;
  margin-bottom: 25px;
}

.heading-2, .card-content h4, .banner-bg-content .banner-container .banner-content .smalltext {
  font-size: 35px;
  line-height: 50px;
}

.heading-3 {
  font-size: 30px;
  line-height: 60px;
  margin-bottom: 15px;
}

/*--Buttons common--*/
.button-common, .secondary_button, .primary_button, .banner-bg-content .banner-container .banner-btn a {
  background: transparent !important;
  display: inline-block !important;
  padding: 8px 30px !important;
  height: 44px !important;
  border-radius: 50px !important;
  position: relative !important;
  transition: all 0.5s linear !important;
  text-align: center !important;
  vertical-align: middle !important;
  text-decoration: none !important;
  outline: 0px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 0px !important;
  cursor: pointer !important;
  text-transform: capitalize !important;
}

.link_button, .banner-bg-content .banner-container .banner-btn a {
  padding: 8px 40px !important;
  line-height: 1.5 !important;
  height: fit-content !important;
}

.primary, .secondary_button:hover, .primary_button, .banner-bg-content .banner-container .banner-btn a {
  border: 3px solid var(--primary) !important;
  background-color: var(--primary) !important;
  color: var(--white) !important;
  box-shadow: none !important;
}

.secondary, .secondary_button, .primary_button:hover, .banner-bg-content .banner-container .banner-btn a:hover {
  border: 3px solid var(--primary) !important;
  background-color: var(--primary) !important;
  color: var(--white) !important;
  box-shadow: none !important;
}

.stepper-next-btn:hover {
  border: 0px !important;
}

.primary_button span.MuiTouchRipple-root, .banner-bg-content .banner-container .banner-btn a span.MuiTouchRipple-root {
  display: none;
}

.secondary_button span.MuiTouchRipple-root {
  display: none;
}

.seeanalytics {
  padding: 8px 18px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  height: 33px !important;
}
.seeanalytics:hover, .seeanalytics:active, .seeanalytics:focus {
  background-color: var(--primary) !important;
}

.btn-wid, .banner-bg-content .banner-container .banner-btn a {
  padding: 10px 40px !important;
  margin-top: 25px;
  margin-right: 13px;
}

/* --banner-style-- */
.banner-bg-content .banner-container {
  padding-top: 30px;
  padding-bottom: 30px;
  min-height: 585px;
}
.banner-bg-content .banner-container .banner-content {
  padding: 0px;
  color: var(--white);
  font-style: normal;
}
.banner-bg-content .banner-container .banner-content .smalltext {
  font-weight: 600 !important;
  line-height: 68px !important;
  color: #07748f !important;
  margin-bottom: 0 !important;
  margin-top: 17px !important;
}
.banner-bg-content .banner-container .banner-content p {
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 1rem;
}
.banner-bg-content .banner-container .banner-img img {
  width: 119%;
  position: relative;
  top: -10px;
  left: 74px;
  height: auto;
}
.banner-bg-content .banner-container .banner-btn a {
  box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, 0.3);
}
.banner-bg-content .banner-container .banner-btn a:nth-child(2) {
  background-color: transparent !important;
  border: 2px solid var(--white) !important;
}
.banner-bg-content .banner-container .banner-btn a:hover {
  box-shadow: none;
}

/* -- card-style -- */
.card-content {
  background-color: rgba(7, 116, 143, 0.05);
}
.card-content h4 {
  margin-bottom: 40px;
}
.card-content .section-card {
  width: 100%;
  margin-left: auto;
  display: block;
  height: 105px;
  background: var(--white);
  box-shadow: 0 4px 20px rgba(23, 125, 150, 0.2);
  border-radius: 20px;
  padding: 10px 18px 10px 6px;
  margin-bottom: 25px;
  transition: all 0.5s ease-in-out;
  flex-direction: unset !important;
}
.card-content .section-card p {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 0;
  margin-left: 10px;
}
.card-content .section-card:hover {
  transform: scale(1.05);
  box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, 0.3) !important;
}

.btn-wid, .banner-bg-content .banner-container .banner-btn a {
  padding: 10px 40px !important;
  margin-top: 25px;
  margin-right: 13px;
}

/* --banner-style-- */
.banner-bg-content .banner-container {
  padding-top: 30px;
  padding-bottom: 30px;
  min-height: 585px;
}
.banner-bg-content .banner-container .banner-content {
  padding: 0px;
  color: var(--white);
  font-style: normal;
}
.banner-bg-content .banner-container .banner-content .smalltext {
  font-weight: 600 !important;
  line-height: 68px !important;
  color: #07748f !important;
  margin-bottom: 0 !important;
  margin-top: 17px !important;
}
.banner-bg-content .banner-container .banner-content p {
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 1rem;
}
.banner-bg-content .banner-container .banner-img img {
  width: 119%;
  position: relative;
  top: -10px;
  left: 74px;
  height: auto;
}
.banner-bg-content .banner-container .banner-btn a {
  box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, 0.3);
}
.banner-bg-content .banner-container .banner-btn a:nth-child(2) {
  background-color: transparent !important;
  border: 2px solid var(--white) !important;
}
.banner-bg-content .banner-container .banner-btn a:hover {
  box-shadow: none;
}

/* -- card-style -- */
.card-comman {
  background: #fff;
  box-shadow: 0 4px 40px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
}

.card-content {
  background-color: rgba(7, 116, 143, 0.05);
}
.card-content h4 {
  margin-bottom: 40px;
}
.card-content .section-card {
  width: 100%;
  margin-left: auto;
  display: block;
  height: 105px;
  background: var(--white);
  box-shadow: 0 4px 20px rgba(23, 125, 150, 0.2);
  border-radius: 20px;
  padding: 10px 18px 10px 6px;
  margin-bottom: 25px;
  transition: all 0.5s ease-in-out;
  flex-direction: unset !important;
}
.card-content .section-card .h-op-features {
  font-weight: 600 !important;
  margin-bottom: 5px !important;
}
.card-content .section-card p {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 0;
  margin-left: 10px;
}
.card-content .section-card:hover {
  transform: scale(1.05);
  box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, 0.3) !important;
}

.header-style {
  height: 74px;
}
.header-style header {
  background-color: var(--white) !important;
  padding: 16px 10px 16px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15) !important;
}
.header-style .menusection li {
  padding: 0px;
  margin-right: 25px;
}
.header-style .menusection li:hover {
  background: none;
}
.header-style .menusection li:last-child {
  margin-right: 0px;
}
.header-style li,
.header-style a,
.header-style span {
  font-style: normal;
  display: flex;
  align-items: center;
}
.header-style .active-menu {
  position: relative;
  display: flex;
  justify-content: center;
}
.header-style .active-menu .sub-menu a {
  color: var(--info) !important;
}
.header-style .active-menu li, .header-style .active-menu a, .header-style .active-menu span {
  color: var(--primary) !important;
}
.header-style .active-menu .active-img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  position: absolute;
  top: -18px;
  background-repeat: no-repeat;
  background-size: 91%;
  width: 48px;
  height: 18px;
  transition: transform 0.2s;
}
.header-style .MuiToolbar-root {
  min-height: 0px;
}
.header-style .logo {
  width: 150px;
}
.header-style .logo img {
  width: 100%;
  padding: 0px;
  height: auto;
  image-resolution: 300dpi;
  image-rendering: crisp-edges;
  filter: contrast(105%);
}
.header-style .login-btn {
  color: var(--white);
  border: 2px solid var(--primary);
  background: linear-gradient(to left, var(--primary) 50%, var(--white) 50%) right;
  border-radius: 5px;
  padding: 5px 25px;
  text-transform: capitalize;
  text-align: center;
  font-weight: 600;
  background-size: 200%;
  transition: 0.4s ease-out;
}
.header-style .login-btn svg {
  margin-right: 5px;
}
.header-style .login-btn svg path {
  fill: var(--white);
}
.header-style .product {
  position: relative;
}
.header-style .product span svg {
  position: relative;
  margin-left: 2px;
  font-size: 20px;
}
.header-style .product .drop_down {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  padding: 0;
  margin: 0;
  background-color: var(--white);
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}
.header-style .product .drop_down li {
  padding: 8px 16px;
  list-style: none;
  cursor: pointer;
}
.header-style .product .drop_down li:hover, .header-style .product .drop_down li:hover a {
  background-color: #fff;
  color: var(--primary) !important;
  transition: all 0.2s ease-in-out;
}
.header-style .product:hover .drop_down {
  display: block;
  z-index: 1;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  padding: 2px 0;
  border-radius: 0 0 5px 5px;
  min-width: 165px;
}
.header-style .product:hover .extend-width {
  min-width: 280px !important;
}

/*-- languages --*/
.languages {
  margin-right: 15px;
}
.languages .dropdown button.dropbtn {
  position: relative;
  top: 1px;
  background-color: transparent;
  border: 2px solid var(--info);
  border-radius: 5px;
  padding: 5px 7px 5px 14px;
  text-transform: capitalize;
  width: 124px;
  justify-content: space-between;
}
.languages .dropdown-content {
  padding: 9px 8px 0px;
  margin: 4px 0px 0px 4px;
  width: 115px;
  position: absolute;
  top: 91%;
  background: var(--white);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  display: none;
}
.languages .dropdown-content button {
  display: block;
  margin: 0px 0px 7px 2px;
  border: 0px;
  padding: 0px;
}
.languages .dropdown-content button:focus, .languages .dropdown-content button:active, .languages .dropdown-content button:hover {
  outline: 0px !important;
  box-shadow: none !important;
  color: var(--primary) !important;
  background-color: transparent !important;
}
.languages:hover .dropdown-content {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/style.scss","webpack://./src/components/static/header/header.scss"],"names":[],"mappings":"AAAA,YAAA;AAIA;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,kEAAA;EACA,yDAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;ACAF;;ADGA,yBAAA;AAIA,kBAAA;AAsFA,kBAAA;AAqCA,oBAAA;AASA,qBAAA;AAmBA,kBAAA;AAYA,oBAAA;AAaA,gBAAA;AAKA,yBAAA;AAMA,mBAAA;AAGA,2BAAA;AACA;;;EACE,eAhLM;EAiLN,kBAAA;EACA,gBAnEM;ACnHR;;ADyLA,eAAA;AACA;EACE,WAnDQ;EAoDR,aAhDK;ACtIP;;ADyLA,kBAAA;AACA;EACE,eAjMM;EAkMN,mBAAA;ACtLF;;ADyLA;EAEE,UAAA;EACA,qBAAA;EACA,eA/MK;EAgNL,gBAxFM;AC/FR;;AD0LA;EACE,qBAAA;EACA,yBAtDK;EAuDL,+BAAA;ACvLF;;AD0LA;EACE,kBApCO;EAqCP,gBAAA;ACvLF;;AD0LA;EACE,eAxLM;EAyLN,iBAtKM;EAuKN,mBA5MM;ACqBR;;AD2LA;EACE,eAvMM;EAwMN,iBAzLM;ACCR;;AD4LA;EACE,eAlNM;EAmNN,iBArLM;EAsLN,mBAnOM;AC0CR;;AD6LA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AC1LF;;AD8LA;EAEE,YAjOM;EAkON,iBAlOM;EAmON,YAAA;EACA,mBAAA;EACA,mBAAA;AC5LF;;AD+LA,kBAAA;AACA;EACE,kBAzFS;EA0FT,aAnHK;EAoHL,sBAjGO;EAkGP,YAAA;EACA,qBAlGU;EAmGV,8BAAA;EACA,2BAnGU;EAoGV,sCAAA;EACA,sBAAA;EACA,mDAAA;EACA,kBAAA;AC5LF;;AD+LA;EACE,qBAAA;EACA,yBApHK;EAqHL,+BAAA;AC5LF;;AD+LA;EACE,kBAlGO;EAmGP,gBAAA;AC5LF;;AD+LA;EACE,eAtPM;EAuPN,iBApOM;EAqON,mBA1QM;AC8ER;;ADgMA;EACE,eArQM;EAsQN,iBAvPM;AC0DR;;ADiMA;EACE,eAhRM;EAiRN,iBAnPM;EAoPN,mBAjSM;ACmGR;;ADkMA,qBAAA;AACA;EACE,kCAAA;EACA,gCAAA;EACA,4BAAA;EACA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,sCAAA;EACA,6BAAA;EACA,iCAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,0BAAA;EACA,qCAAA;AC/LF;;ADkMA;EACE,4BAAA;EACA,2BAAA;EACA,8BAAA;AC/LF;;ADkMA;EACE,2CAAA;EACA,2CAAA;EACA,8BAAA;EACA,2BAAA;AC/LF;;ADkMA;EACE,2CAAA;EACA,2CAAA;EACA,8BAAA;EACA,2BAAA;AC/LF;;ADiMA;EACE,sBAAA;AC9LF;;ADyME;EACE,aAAA;ACtMJ;;ADkNE;EACE,aAAA;AC/MJ;;ADkNA;EACE,4BAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;AC/MF;ADgNE;EACE,2CAAA;AC9MJ;;ADkNA;EACE,6BAAA;EACA,gBAAA;EACA,kBAAA;AC/MF;;ADkNA,qBAAA;AAEE;EACE,iBA7WI;EA8WJ,oBA9WI;EA+WJ,iBAAA;AChNJ;ADkNI;EACE,YAjZC;EAkZD,mBAAA;EACA,kBAxNG;ACQT;ADkNM;EACE,2BAAA;EACA,4BAAA;EACA,yBAAA;EACA,2BAAA;EACA,2BAAA;AChNR;ADwNM;EACE,gBAvSA;EAwSA,eA/YA;EAgZA,iBAtYA;EAuYA,mBAAA;ACtNR;AD2NM;EACE,WAAA;EACA,kBA7PG;EA8PH,UAAA;EACA,UAAA;EACA,YAtRD;AC6DP;AD8NM;EAEE,oDAAA;AC7NR;AD+NQ;EACE,wCAAA;EACA,yCAAA;AC7NV;ADmOQ;EACE,gBArSH;ACoEP;;ADwOA,qBAAA;AACA;EACE,yCAAA;ACrOF;ADuOE;EACE,mBAraI;ACgMR;ADyOE;EACE,WAhUM;EAiUN,iBA1TG;EA2TH,cA7TI;EA8TJ,aAAA;EACA,wBAAA;EACA,8CAAA;EACA,mBApcI;EAqcJ,2BAAA;EACA,mBAjcI;EAkcJ,gCAAA;EACA,gCAAA;ACvOJ;ADyOI;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;ACvON;AD0OI;EACE,sBAAA;EACA,+DAAA;ACxON;;AD6OE;EACE,6BAAA;EACA,gBAAA;EACA,kBAAA;AC1OJ;;AD6OE,qBAAA;AAEE;EACE,iBAzdE;EA0dF,oBA1dE;EA2dF,iBAAA;AC3ON;AD6OM;EACE,YA7fD;EA8fC,mBAAA;EACA,kBApUC;ACyFT;AD6OQ;EACE,2BAAA;EACA,4BAAA;EACA,yBAAA;EACA,2BAAA;EACA,2BAAA;AC3OV;ADmPQ;EACE,gBAnZF;EAoZE,eA3fF;EA4fE,iBAlfF;EAmfE,mBAAA;ACjPV;ADsPQ;EACE,WAAA;EACA,kBAzWC;EA0WD,UAAA;EACA,UAAA;EACA,YAlYH;AC8IP;ADyPQ;EAEE,oDAAA;ACxPV;AD0PU;EACE,wCAAA;EACA,yCAAA;ACxPZ;AD8PU;EACE,gBAjZL;ACqJP;;ADmQE,qBAAA;AACA;EACE,gBAAA;EACA,yCAAA;EACA,mBAAA;AChQJ;;ADmQE;EACE,yCAAA;AChQJ;ADkQI;EACE,mBAvhBE;ACuRR;ADoQI;EACE,WAlbI;EAmbJ,iBA5aC;EA6aD,cA/aE;EAgbF,aAAA;EACA,wBAAA;EACA,8CAAA;EACA,mBAtjBE;EAujBF,2BAAA;EACA,mBAnjBE;EAojBF,gCAAA;EACA,gCAAA;AClQN;ADoQM;EACE,2BAAA;EACA,6BAAA;AClQR;ADqQM;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;ACnQR;ADsQM;EACE,sBAAA;EACA,+DAAA;ACpQR;;AA1XA;EACI,YDgGI;AC6RR;AA3XI;EACI,yCAAA;EACA,uBAAA;EACA,mDAAA;AA6XR;AAzXQ;EACI,YDkBL;ECjBK,kBD2CJ;ACgVR;AAzXY;EACI,gBD2KT;ACgNP;AAxXY;EACI,iBDUT;ACgXP;AArXI;;;EAII,kBD4LC;EC3LD,aDuJD;ECtJC,mBDoKC;ACkNT;AApXI;EACI,kBAAA;EACA,aAAA;EACA,uBAAA;AAsXR;AArXQ;EACI,6BAAA;AAuXZ;AArXQ;EACI,gCAAA;AAuXZ;AApXQ;EACI,yDAAA;EACA,kBAAA;EACA,UAAA;EACA,4BAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EAEA,0BAAA;AAuXZ;AAlXI;EACI,eD7BD;ACiZP;AAjXI;EACI,YD4CC;ACuUT;AAjXQ;EACI,WD+GF;EC9GE,YDrCL;ECsCK,YDoHL;ECnHK,wBAAA;EACA,4BAAA;EAEA,sBAAA;AAmXZ;AA/WI;EACI,mBAAA;EACA,gCAAA;EACA,gFAAA;EACA,kBD7CD;EC8CC,iBAAA;EACA,0BDmIK;EClIL,kBDgHC;EC/GD,gBDwEA;ECvEA,qBD6FE;EC5FF,yBAAA;AAiXR;AA/WQ;EACI,iBDtDL;ACuaP;AA/WY;EACI,kBAAA;AAiXhB;AAlWI;EACI,kBDkGG;ACkQX;AAjWY;EACI,kBD8FL;EC7FK,gBDjFT;ECkFS,eD/DR;ACkaR;AA/VQ;EACI,aDoEL;ECnEK,kBDuFD;ECtFC,SDwDF;ECvDE,OAAA;EACA,UAAA;EACA,SAAA;EACA,8BAAA;EACA,0CAAA;AAiWZ;AA/VY;EACI,iBAAA;EACA,gBDyDT;ECxDS,eAAA;AAiWhB;AAhWgB;EACI,sBAAA;EACA,gCAAA;EACA,gCAAA;AAkWpB;AA5VY;EACI,cDwCR;ECvCQ,UAAA;EACA,yCAAA;EACA,cAAA;EACA,0BAAA;EACA,gBAAA;AA8VhB;AA5VY;EACI,2BAAA;AA8VhB;;AAxVA,kBAAA;AACA;EACI,kBDhHI;AC2cR;AAxVQ;EAEI,kBD2CD;EC1CC,QDrIL;ECsIK,6BDwBE;ECvBF,6BAAA;EACA,kBDpIL;ECqIK,yBAAA;EACA,0BD4CC;EC3CD,YDjEH;ECkEG,8BD4BI;AC6ThB;AArVI;EACI,oBAAA;EACA,uBAAA;EACA,YD3EC;EC4ED,kBD4BG;EC3BH,QDJC;ECKD,wBAAA;EACA,2CAAA;EACA,kBDpJD;ECqJC,aDGD;ACoVP;AAtVQ;EAEI,cDLJ;ECMI,uBAAA;EACA,WD/JL;ECgKK,YDhKL;ACufP;AArVY;EAGI,uBAAA;EACA,2BAAA;EACA,gCAAA;EACA,wCAAA;AAqVhB;AAhVQ;EACI,cAAA;AAkVZ","sourcesContent":["/*--Fonts--*/\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');\n\n:root {\n  --primary: #FF914E;\n  --secondary: #07748F;\n  --info: #343833;\n  --white: #FFFFFF;\n  --black: #000000;\n  --liteblue: #e7f3f5;\n  --shadeblue: #d1e6eb;\n  --hrborder: #e4dede;\n  --theader: #f5f7f8;\n  --thinfo: #384648;\n  --thborder: #dee2e6;\n  --dlink: #007bff;\n  --btninfo: #313232;\n  --gary: #5a6e82;\n  --high-to-low: linear-gradient(to right, #07748F 0%, #72B0C0 100%);\n  --low-to-high: linear-gradient(90deg, #72B0C0 0, #07748F);\n  --red: #f15e48;\n  --green: #02681a;\n  --lowgray: #A0B2B5;\n}\n\n/* ---- font family ----*/\n$montserrat : 'Montserrat';\n$roboto: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n\n/*--- pixels --- */\n$px-0: 0px;\n$px-1: 1px;\n$px-2: 2px;\n$px-3: 3px;\n$px-4: 4px;\n$px-5: 5px;\n$px-6: 6px;\n$px-7: 7px;\n$px-8: 8px;\n$px-9: 9px;\n$px-10: 10px;\n$px-11: 11px;\n$px--11: -11px;\n$px-12: 12px;\n$px-13: 13px;\n$px-14: 14px;\n$px-15: 15px;\n$px-16: 16px;\n$px-17: 17px;\n$px-18: 18px;\n$px-19: 19px;\n$px-20: 20px;\n$px-21: 21px;\n$px-22: 22px;\n$px-23: 23px;\n$px-24: 24px;\n$px-25: 25px;\n$px-26: 26px;\n$px-27: 27px;\n$px-28: 28px;\n$px-29: 29px;\n$px-30: 30px;\n$px-31: 31px;\n$px-32: 32px;\n$px-33: 33px;\n$px-34: 34px;\n$px-35: 35px;\n$px-36: 36px;\n$px-37: 37px;\n$px-38: 38px;\n$px-39: 39px;\n$px-40: 40px;\n$px-41: 41px;\n$px-42: 42px;\n$px-43: 43px;\n$px-44: 44px;\n$px-45: 45px;\n$px-46: 46px;\n$px-47: 47px;\n$px-48: 48px;\n$px-49: 49px;\n$px-50: 50px;\n$px-51: 51px;\n$px-52: 52px;\n$px-53: 53px;\n$px-54: 54px;\n$px-55: 55px;\n$px-56: 56px;\n$px-57: 57px;\n$px-58: 58px;\n$px-59: 59px;\n$px-60: 60px;\n$px-61: 61px;\n$px-62: 62px;\n$px-63: 63px;\n$px-64: 64px;\n$px-65: 65px;\n$px-70: 70px;\n$px-74: 74px;\n$px-75: 75px;\n$px-80: 80px;\n$px-85: 85px;\n$px-100: 100px;\n$px-115: 115px;\n$px-120: 120px;\n$px-124: 124px;\n$px-130: 130px;\n$px-150: 150px;\n$px-200: 200px;\n$px-226: 226px;\n$px-250: 250px;\n$px-280: 280px;\n$px-300: 300px;\n$px-585: 585px;\n\n/*---font size---*/\n$f-10: $px-10;\n$f-11: $px-11;\n$f-12: $px-12;\n$f-13: $px-13;\n$f-14: $px-14;\n$f-15: $px-15;\n$f-16: $px-16;\n$f-17: $px-17;\n$f-18: $px-18;\n$f-19: $px-19;\n$f-20: $px-20;\n$f-21: $px-21;\n$f-22: $px-22;\n$f-23: $px-23;\n$f-24: $px-24;\n$f-25: $px-25;\n$f-26: $px-26;\n$f-27: $px-27;\n$f-28: $px-28;\n$f-29: $px-29;\n$f-30: $px-30;\n$f-31: $px-31;\n$f-32: $px-32;\n$f-33: $px-33;\n$f-34: $px-34;\n$f-35: $px-35;\n$f-36: $px-36;\n$f-37: $px-37;\n$f-38: $px-38;\n$f-39: $px-39;\n$f-40: $px-40;\n$f-41: $px-41;\n$f-42: $px-42;\n$f-43: $px-43;\n$f-46: $px-46;\n\n/*---font weight---*/\n$f-300: 300;\n$f-400: 400;\n$f-500: 500;\n$f-600: 600;\n$f-700: 700;\n$f-800: 800;\n$f-900: 900;\n\n/*--- percentage ---*/\n$per-8: 8%;\n$per-10: 10%;\n$per-18: 18%;\n$per-30: 30%;\n$per-35: 35%;\n$per-38: 38%;\n$per-40: 40%;\n$per-45: 45%;\n$per-48: 48%;\n$per-50: 50%;\n$per-55: 55%;\n$per-60: 60%;\n$per-85: 85%;\n$per-90: 90%;\n$per-91: 91%;\n$per-100: 100%;\n$per-200: 200%;\n\n/*--- display ---*/\n$flex: flex;\n$block: block;\n$grid: grid;\n$auto: auto;\n$inlineblock: inline-block;\n$row: row;\n$none: none;\n$max-content: max-content;\n$transparent: transparent;\n$no-repeat: no-repeat;\n\n/*--- alignment ---*/\n$top: top;\n$left: left;\n$center: center;\n$right: right;\n$bottom: bottom;\n$middle: middle;\n$space-between: space-between;\n$column: column;\n$breakword: break-word;\n$borderbox: border-box;\n$end: end;\n\n/*--Position --*/\n$relative: relative;\n$absolute: absolute;\n$initial: initial;\n\n/*--- Text Transform ---*/\n$uppercase: uppercase;\n$lowercase: lowercase;\n$capitalize: capitalize;\n$underline: underline;\n\n/*-- Text Style --*/\n$normal: normal;\n\n/*-- Info and paragraph --*/\n.font-common {\n  font-size: $f-14;\n  color: var(--info);\n  font-weight: $f-600;\n}\n\n/*--Flex-box--*/\n.w-flex {\n  width: $per-100;\n  display: $flex;\n}\n\n/*-- Form Label--*/\n.input-fonts {\n  font-size: $f-11;\n  color: var(--black);\n}\n\n.formlabel {\n  @extend .input-fonts;\n  opacity: 1;\n  margin-bottom: 0.3rem;\n  margin-top: $px-5;\n  font-weight: $f-500;\n}\n\n.login-btn-hover {\n  color: var(--primary);\n  background-position: $left;\n  fill: var(--primary) !important;\n}\n\n.heading-comman {\n  font-style: $normal;\n  font-weight: 700;\n}\n\n.heading-1 {\n  font-size: $f-43;\n  line-height: $px-62;\n  margin-bottom: $px-25;\n  @extend .heading-comman;\n}\n\n.heading-2 {\n  font-size: $f-35;\n  line-height: $px-50;\n  @extend .heading-comman;\n}\n\n.heading-3 {\n  font-size: $f-30;\n  line-height: $px-60;\n  margin-bottom: $px-15;\n  @extend .heading-comman;\n}\n\n.heading-4 {\n  font-weight: 600;\n  font-size: 25px;\n  line-height: 26px;\n  @extend .heading-comman;\n}\n\n.inputfields {\n  @extend .input-fonts;\n  height: $px-30;\n  line-height: $px-30;\n  opacity: .8;\n  padding: $px-0 0.5rem;\n  background: #F4F6F7;\n}\n\n/*-- Box outer --*/\n.boxing {\n  position: $relative;\n  display: $flex;\n  flex-direction: $column;\n  min-width: 0;\n  word-wrap: $breakword;\n  background-color: var(--white);\n  background-clip: $borderbox;\n  border: $px-1 solid rgba(0, 0, 0, .125);\n  border-radius: 0.25rem;\n  box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075);\n  padding: $px-15 $px-15;\n}\n\n.login-btn-hover {\n  color: var(--primary);\n  background-position: $left;\n  fill: var(--primary) !important;\n}\n\n.heading-comman {\n  font-style: $normal;\n  font-weight: 700;\n}\n\n.heading-1 {\n  font-size: $f-43;\n  line-height: $px-62;\n  margin-bottom: $px-25;\n  @extend .heading-comman;\n}\n\n.heading-2 {\n  font-size: $f-35;\n  line-height: $px-50;\n  @extend .heading-comman;\n}\n\n.heading-3 {\n  font-size: $f-30;\n  line-height: $px-60;\n  margin-bottom: $px-15;\n  @extend .heading-comman;\n}\n\n/*--Buttons common--*/\n.button-common {\n  background: $transparent  !important;\n  display: $inlineblock  !important;\n  padding: $px-8 $px-30  !important;\n  height: $px-44  !important;\n  border-radius: $px-50  !important;\n  position: $relative  !important;\n  transition: all .5s linear !important;\n  text-align: $center  !important;\n  vertical-align: $middle  !important;\n  text-decoration: $none  !important;\n  outline: $px-0  !important;\n  font-size: $f-16  !important;\n  font-weight: $f-600  !important;\n  line-height: $px-0  !important;\n  cursor: pointer !important;\n  text-transform: $capitalize  !important;\n}\n\n.link_button {\n  padding: $px-8 $px-40  !important;\n  line-height: 1.5 !important;\n  height: fit-content !important;\n}\n\n.primary {\n  border: $px-3 solid var(--primary) !important;\n  background-color: var(--primary) !important;\n  color: var(--white) !important;\n  box-shadow: none!important;\n}\n\n.secondary {\n  border: $px-3 solid var(--primary) !important;\n  background-color: var(--primary) !important;\n  color: var(--white) !important;\n  box-shadow: none!important;\n}\n.stepper-next-btn:hover {\n  border: 0px !important;\n}\n\n.primary_button {\n  @extend .button-common;\n  @extend .primary;\n\n  &:hover {\n    @extend .secondary;\n  }\n\n  span.MuiTouchRipple-root {\n    display: none;\n  }\n}\n\n.secondary_button {\n  @extend .button-common;\n  @extend .secondary;\n\n  &:hover {\n    @extend .primary;\n  }\n\n  span.MuiTouchRipple-root {\n    display: none;\n  }\n}\n.seeanalytics {\n  padding: 8px 18px!important;\n  font-size: 13px!important;\n  font-weight: 500!important;\n  height: 33px!important;\n  &:hover, &:active, &:focus {\n    background-color: var(--primary)!important;\n  }\n}\n\n.btn-wid {\n  padding: 10px 40px !important;\n  margin-top: 25px;\n  margin-right: 13px;\n}\n\n/* --banner-style-- */\n.banner-bg-content {\n  .banner-container {\n    padding-top: $px-30;\n    padding-bottom: $px-30;\n    min-height: 585px;\n\n    .banner-content {\n      padding: $px-0;\n      color: var(--white);\n      font-style: $normal;\n\n      .smalltext {\n        font-weight: 600 !important;\n        line-height: 68px !important;\n        color: #07748f !important;\n        margin-bottom: 0 !important;\n        margin-top: 17px !important;\n        @extend .heading-2;\n      }\n\n      h1 {\n        @extend .heading-1;\n      }\n\n      p {\n        font-weight: $f-400;\n        font-size: $f-20;\n        line-height: $px-30;\n        margin-bottom: 1rem;\n      }\n    }\n\n    .banner-img {\n      img {\n        width: 119%;\n        position: $relative;\n        top: -$px-10;\n        left: 74px;\n        height: $auto;\n      }\n    }\n\n    .banner-btn {\n      a {\n        @extend .link_button;\n        box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, .3);\n\n        &:nth-child(2) {\n          background-color: $transparent  !important;\n          border: 2px solid var(--white) !important;\n        }\n\n        @extend .btn-wid;\n        @extend .primary_button;\n\n        &:hover {\n          box-shadow: $none;\n        }\n      }\n    }\n  }\n}\n\n/* -- card-style -- */\n.card-content {\n  background-color: rgba(7, 116, 143, .05);\n\n  h4 {\n    margin-bottom: $px-40;\n    @extend .heading-2;\n  }\n\n  .section-card {\n    width: $per-100;\n    margin-left: $auto;\n    display: $block;\n    height: 105px;\n    background: var(--white);\n    box-shadow: 0 4px 20px rgba(23, 125, 150, .2);\n    border-radius: $px-20;\n    padding: 10px 18px 10px 6px;\n    margin-bottom: $px-25;\n    transition: all .5s ease-in-out;\n    flex-direction: unset !important;\n\n    p {\n      font-style: normal;\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 22px;\n      margin-bottom: 0;\n      margin-left: 10px;\n    }\n\n    &:hover {\n      transform: scale(1.05);\n      box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, .3) !important;\n    }\n  }\n}\n\n  .btn-wid {\n    padding: 10px 40px !important;\n    margin-top: 25px;\n    margin-right: 13px;\n  }\n\n  /* --banner-style-- */\n  .banner-bg-content {\n    .banner-container {\n      padding-top: $px-30;\n      padding-bottom: $px-30;\n      min-height: 585px;\n\n      .banner-content {\n        padding: $px-0;\n        color: var(--white);\n        font-style: $normal;\n\n        .smalltext {\n          font-weight: 600 !important;\n          line-height: 68px !important;\n          color: #07748f !important;\n          margin-bottom: 0 !important;\n          margin-top: 17px !important;\n          @extend .heading-2;\n        }\n\n        h1 {\n          @extend .heading-1;\n        }\n\n        p {\n          font-weight: $f-400;\n          font-size: $f-20;\n          line-height: $px-30;\n          margin-bottom: 1rem;\n        }\n      }\n\n      .banner-img {\n        img {\n          width: 119%;\n          position: $relative;\n          top: -$px-10;\n          left: 74px;\n          height: $auto;\n        }\n      }\n\n      .banner-btn {\n        a {\n          @extend .link_button;\n          box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, .3);\n\n          &:nth-child(2) {\n            background-color: $transparent  !important;\n            border: 2px solid var(--white) !important;\n          }\n\n          @extend .btn-wid;\n          @extend .primary_button;\n\n          &:hover {\n            box-shadow: $none;\n          }\n        }\n      }\n    }\n  }\n\n  /* -- card-style -- */\n  .card-comman {\n    background: #fff;\n    box-shadow: 0 4px 40px rgba(0, 0, 0, .1);\n    border-radius: 20px;\n  }\n\n  .card-content {\n    background-color: rgba(7, 116, 143, .05);\n\n    h4 {\n      margin-bottom: $px-40;\n      @extend .heading-2;\n    }\n\n    .section-card {\n      width: $per-100;\n      margin-left: $auto;\n      display: $block;\n      height: 105px;\n      background: var(--white);\n      box-shadow: 0 4px 20px rgba(23, 125, 150, .2);\n      border-radius: $px-20;\n      padding: 10px 18px 10px 6px;\n      margin-bottom: $px-25;\n      transition: all .5s ease-in-out;\n      flex-direction: unset !important;\n\n      .h-op-features {\n        font-weight: 600 !important;\n        margin-bottom: 5px !important;\n      }\n\n      p {\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 22px;\n        margin-bottom: 0;\n        margin-left: 10px;\n      }\n\n      &:hover {\n        transform: scale(1.05);\n        box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, .3) !important;\n      }\n    }\n  }","@import \"../../../style.scss\";\n\n.header-style {\n    height: $px-74;\n\n    header {\n        background-color: var(--white) !important;\n        padding: $px-16 $px-10 $px-16;\n        box-shadow: 0 0 10px rgba(0, 0, 0, .15) !important;\n    }\n\n    .menusection {\n        li {\n            padding: $px-0;\n            margin-right: $px-25;\n\n            &:hover {\n                background: $none;\n            }\n\n            &:last-child {\n                margin-right: $px-0;\n            }\n        }\n    }\n\n    li,\n    a,\n    span {\n        @extend .font-common;\n        font-style: $normal;\n        display: $flex;\n        align-items: $center;\n    }\n    .active-menu{\n        position: relative;\n        display: flex;\n        justify-content: center;\n        .sub-menu a{\n            color: var(--info) !important;\n        }\n        li,a,span{\n            color: var(--primary) !important;\n        }\n        \n        .active-img{\n            background-image: url(../../../assets/images/active.webp);\n            position: absolute;\n            top: -18px;\n            background-repeat: no-repeat;\n            background-size: 91%;\n            width: 48px;\n            height: 18px;\n            transition: -webkit-transform .2s;\n            transition: transform .2s;\n            transition: transform .2s,-webkit-transform .2s;\n        }\n    }\n\n    .MuiToolbar-root {\n        min-height: $px-0;\n    }\n\n    .logo {\n        width: $px-150;\n\n        img {\n            width: $per-100;\n            padding: $px-0;\n            height: $auto;\n            image-resolution: 300dpi;\n            image-rendering: crisp-edges;\n            -webkit-filter: contrast(105%);\n            filter: contrast(105%);\n        }\n    }\n\n    .login-btn {\n        color: var(--white);\n        border: $px-2 solid var(--primary);\n        background: linear-gradient(to left, var(--primary) 50%, var(--white) 50%) right;\n        border-radius: $px-5;\n        padding: $px-5 $px-25;\n        text-transform: $capitalize;\n        text-align: $center;\n        font-weight: $f-600;\n        background-size: $per-200;\n        transition: .4s ease-out;\n\n        svg {\n            margin-right: $px-5;\n\n            path {\n                fill: var(--white);\n            }\n        }\n\n        &:hover {\n            @extend .login-btn-hover;\n\n            svg {\n                path {\n                    @extend .login-btn-hover;\n                }\n            }\n        }\n    }\n\n    .product {\n        position: $relative;\n\n        span {\n            svg {\n                position: $relative;\n                margin-left: $px-2;\n                font-size: $f-20;\n            }\n        }\n\n        .drop_down {\n            display: $none;\n            position: $absolute;\n            top: $per-100;\n            left: 0;\n            padding: 0;\n            margin: 0;\n            background-color: var(--white);\n            box-shadow: $px-0 $px-2 $px-4 rgba(0, 0, 0, 0.1);\n\n            li {\n                padding: $px-8 $px-16;\n                list-style: $none;\n                cursor: pointer;\n                &:hover, &:hover a{\n                    background-color: #fff;\n                    color: var(--primary) !important;\n                    transition: all .2s ease-in-out;\n                }\n            }\n        }\n\n        &:hover {\n            .drop_down {\n                display: $block;\n                z-index: 1;\n                box-shadow: 0 4px 10px rgba(0,0,0,.2);\n                padding: 2px 0;\n                border-radius: 0 0 5px 5px;\n                min-width: 165px;\n            }\n            .extend-width{\n                min-width: 280px !important;\n            }\n        }\n    }\n}\n\n/*-- languages --*/\n.languages {\n    margin-right: $px-15;\n\n    .dropdown {\n        button.dropbtn {\n            @extend .font-common;\n            position: $relative;\n            top: $px-1;\n            background-color: $transparent;\n            border: $px-2 solid var(--info);\n            border-radius: $px-5;\n            padding: $px-5 $px-7 $px-5 $px-14;\n            text-transform: $capitalize;\n            width: $px-124;\n            justify-content: $space-between;\n        }\n    }\n\n    .dropdown-content {\n        padding: $px-9 $px-8 $px-0;\n        margin: $px-4 $px-0 $px-0 $px-4;\n        width: $px-115;\n        position: $absolute;\n        top: $per-91;\n        background: var(--white);\n        box-shadow: $px-0 $px-4 $px-10 rgba(0,0,0,.2);\n        border-radius: $px-5;\n        display: $none;\n        button {\n            @extend .font-common;\n            display: $block;\n            margin: $px-0 $px-0 $px-7 $px-2;\n            border: $px-0;\n            padding: $px-0;\n\n            &:focus,\n            &:active,\n            &:hover {\n                outline: $px-0  !important;\n                box-shadow: $none  !important;\n                color: var(--primary) !important;\n                background-color: $transparent !important;\n            }\n        }\n    }\n    &:hover {\n        .dropdown-content {\n            display: block;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
